/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppAccountRouteImport } from './routes/_app.account'
import { Route as AppAdminRouteImport } from './routes/_app.admin'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppEpisodesRouteImport } from './routes/_app.episodes'
import { Route as AppTracesIndexRouteImport } from './routes/_app.traces.index'
import { Route as AppTracesTraceIdRouteImport } from './routes/_app.traces.$traceId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppEpisodesRoute = AppEpisodesRouteImport.update({
  id: '/episodes',
  path: '/episodes',
  getParentRoute: () => AppRoute,
} as any)
const AppTracesIndexRoute = AppTracesIndexRouteImport.update({
  id: '/traces/',
  path: '/traces/',
  getParentRoute: () => AppRoute,
} as any)
const AppTracesTraceIdRoute = AppTracesTraceIdRouteImport.update({
  id: '/traces/$traceId',
  path: '/traces/$traceId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/account': typeof AppAccountRoute
  '/admin': typeof AppAdminRoute
  '/dashboard': typeof AppDashboardRoute
  '/episodes': typeof AppEpisodesRoute
  '/traces/$traceId': typeof AppTracesTraceIdRoute
  '/traces/': typeof AppTracesIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/account': typeof AppAccountRoute
  '/admin': typeof AppAdminRoute
  '/dashboard': typeof AppDashboardRoute
  '/episodes': typeof AppEpisodesRoute
  '/': typeof AppIndexRoute
  '/traces/$traceId': typeof AppTracesTraceIdRoute
  '/traces': typeof AppTracesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_app/account': typeof AppAccountRoute
  '/_app/admin': typeof AppAdminRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/episodes': typeof AppEpisodesRoute
  '/_app/': typeof AppIndexRoute
  '/_app/traces/$traceId': typeof AppTracesTraceIdRoute
  '/_app/traces/': typeof AppTracesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/account'
    | '/admin'
    | '/dashboard'
    | '/episodes'
    | '/traces/$traceId'
    | '/traces/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/account'
    | '/admin'
    | '/dashboard'
    | '/episodes'
    | '/'
    | '/traces/$traceId'
    | '/traces'
  id:
    | '__root__'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/_app/account'
    | '/_app/admin'
    | '/_app/dashboard'
    | '/_app/episodes'
    | '/_app/'
    | '/_app/traces/$traceId'
    | '/_app/traces/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/episodes': {
      id: '/_app/episodes'
      path: '/episodes'
      fullPath: '/episodes'
      preLoaderRoute: typeof AppEpisodesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/traces/': {
      id: '/_app/traces/'
      path: '/traces'
      fullPath: '/traces/'
      preLoaderRoute: typeof AppTracesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/traces/$traceId': {
      id: '/_app/traces/$traceId'
      path: '/traces/$traceId'
      fullPath: '/traces/$traceId'
      preLoaderRoute: typeof AppTracesTraceIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppAdminRoute: typeof AppAdminRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppEpisodesRoute: typeof AppEpisodesRoute
  AppIndexRoute: typeof AppIndexRoute
  AppTracesTraceIdRoute: typeof AppTracesTraceIdRoute
  AppTracesIndexRoute: typeof AppTracesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppAdminRoute: AppAdminRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppEpisodesRoute: AppEpisodesRoute,
  AppIndexRoute: AppIndexRoute,
  AppTracesTraceIdRoute: AppTracesTraceIdRoute,
  AppTracesIndexRoute: AppTracesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
